import { createAction } from 'redux-actions';
import { http } from 'helpers/axios';
import { store } from 'store/createStore';

export const loading = createAction('@@home/loading');

export const newCampaign = createAction('@@home/newCampaign');

export const fetchCampaigns = createAction(
  '@@home/fetchCampaigns',
  () => async dispatch => {
    dispatch(loading());
    const { currentGroup } = store.getState().auth;
    let query = `group=${currentGroup._id}`;

    return http.get(`/campaigns?${query}`).get('data');
  }
);

export const activateCampaign = createAction(
  '@@home/activateCampaign',
  (campaignId, checked) => dispatch => {
    dispatch(loading());
    return http.get(`/campaigns/${campaignId}`).then(({ data }) => {
      data.active = checked;
      return http.put(`/campaigns/${campaignId}`, data).get('data');
    });
  }
);

export const deleteCampaign = createAction(
  '@@home/deleteCampaign',
  campaignId => dispatch => {
    return http.delete(`/campaigns/${campaignId}`).get('data');
  }
);
